import React from 'react'

// @src imports
import { Button } from 'src/chrome'

import { noop } from 'src/helpers/appHelpers'
import { useAccount, useActions, useMutations, useState } from 'src/hooks'
// relative imports
import { BaseCreditCard, EditCard, EmptyCard } from '..'
import CreditCard from '../CreditCard/CreditCard'
import { AccountInput } from '../../../__generated__/globalTypes'

import styles from '../../../dashboard/containers/PaymentSettings/styles'

const CreditCardManager: React.FC = () => {
  const [isEditingCard, setIsEditingCard] = useState(false)
  const [isAddingCard, setIsAddingCard] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const actions = useActions()

  const account = useAccount()

  const mutations = useMutations()

  const stripeSource = account.stripeSource
  const accountName = `${account.firstName} ${account.lastName}`

  const updateAccount = async (
    data: AccountInput,
    success: () => void = noop,
    error: (error: Error | string) => void = noop,
  ) => {
    try {
      const {
        updateAccount: { account },
      } = await mutations.updateAccount({ account: { ...data } })
      actions.updatedAccount(account)
      success()
    } catch (err) {
      error(err)
    }
  }

  const removeCard = () => {
    setIsLoading(true)
    updateAccount({ stripeToken: null }, () => {
      setIsLoading(false)
      setIsAddingCard(false)
      setIsEditingCard(false)
    })
  }

  const setCard = (stripeToken: stripe.Token) => {
    setIsLoading(true)
    updateAccount({ stripeToken: stripeToken.id }, () => {
      setIsLoading(false)
      setIsAddingCard(false)
      setIsEditingCard(false)
    })
  }

  return !stripeSource ? (
    <div>
      {!isAddingCard && (
        <BaseCreditCard onClick={() => setIsAddingCard(true)}>
          <EmptyCard message={'Add a Payment Source'} />
        </BaseCreditCard>
      )}
      {isAddingCard && (
        <BaseCreditCard>
          <div css={{ width: '100%', padding: 20 }}>
            <EditCard
              onSuccess={token => setCard(token)}
              onError={() => null}
              isSubmitButtonVisible={true}
              isAddingCard={isLoading}
            />
          </div>
        </BaseCreditCard>
      )}
    </div>
  ) : (
    <div>
      <div css={{ position: 'relative', zIndex: 10 }}>
        <CreditCard
          cardType={
            stripeSource.__typename === 'CreditCard'
              ? stripeSource.brand
              : 'Bank'
          }
          exp={
            stripeSource.__typename === 'CreditCard'
              ? `${stripeSource.expMonth}/${stripeSource.expYear}`
              : '****'
          }
          last4={stripeSource.last4}
          name={accountName}
        />
        {!isEditingCard && (
          <div
            css={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}
          >
            <Button
              onClick={() => setIsEditingCard(true)}
              title={'Edit Card'}
            />
          </div>
        )}
        {isEditingCard && (
          <div css={styles.formCard}>
            <div
              css={{
                display: 'flex',
                width: 400,
                justifyContent: 'space-around',
              }}
            >
              <Button
                title={isLoading ? 'Removing Card...' : 'Remove Card'}
                onClick={removeCard}
                disabled={isLoading}
              />
              <Button
                onClick={() => setIsEditingCard(false)}
                buttonColor={'pink'}
                title={'Done'}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CreditCardManager
